import React from "react";
import downIcon from "../../../../assets/images/classes/downIcon.svg";

const DropDownSupremeChapter = ({openDropdown, setOpenDropdown , level, supremeChapter, setSelectedChapter}) => {
    const isOpen = openDropdown === "supremeChapter"; // ✅ 현재 열린 드롭다운이 "supremeChapter"인지 확인

    const selectSupremeChapter = (item) =>{
        const chapterSelected = {
            level: level.level,
            supremeChapterSeq: item.sequence, // 상위 챕터 ID
            chapterSeq: 0, // 현재 선택된 챕터 ID
        };
        setSelectedChapter(chapterSelected);
        setOpenDropdown(false);
    }

    return (
        <div className="relative">
            <button
                onClick={() => setOpenDropdown(isOpen ? null : "supremeChapter")} // ✅ 클릭 시 다른 드롭다운 닫기
                className="inline-flex w-[211px] h-[44px] justify-center items-center gap-x-1.5 rounded-[10px] bg-white px-3 py-2 font-[500] text-[17px] text-[#000] shadow-custom ring-1 ring-inset ring-gray-300 hover:bg-gray-50 z-20 relative"
            >
                <div className=" text-left truncate pr-2 w-full">
                    {supremeChapter ? `${supremeChapter.supremeChapterSeq}. ${supremeChapter.supremeChapterName}` : "대단원 선택"}
                </div>
                <img src={downIcon} alt="downIcon" className="ml-auto mr-[0px] w-4" />
            </button>

            {isOpen && (
                <div className="absolute w-full z-10 origin-top rounded-b-[10px] bg-white shadow-lg ring-1 ring-black/5 transition-all duration-300 overflow-hidden scrollbar-hide max-h-[300px] opacity-100">
                    <div className="max-h-[300px] overflow-y-auto bg-[#F1F1F1] pt-2">
                        {level && level.supremeChapterList.map((supremeChapterObj) => (
                            <div
                                key={supremeChapterObj.supremeChapterId}
                                className="cursor-pointer hover:bg-blue-50 p-2 truncate text-left ml-[10px]"
                                onClick={() => {
                                    selectSupremeChapter(supremeChapterObj);
                                }}
                            >
                                {`${supremeChapterObj.supremeChapterSeq}. ${supremeChapterObj.supremeChapterName}`}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DropDownSupremeChapter;
